var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntroimg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600.28 355.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2 {\r\n                fill: url(#linear-gradient);\r\n            }\r\n\r\n            .cls-3 {\r\n                fill: url(#linear-gradient-2);\r\n            }\r\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 171.87,
    y1: 178.34,
    x2: 600.28,
    y2: 178.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0074af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1dffe4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 436.35,
    y1: -170.81,
    x2: 557.85,
    y2: 411.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 358.96,
    y1: 208.17,
    x2: 376.22,
    y2: 151.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2077bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2b7ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3e88bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5394bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 171.66,
    y1: 177.77,
    x2: 600.06,
    y2: 177.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 436.14,
    y1: -171.38,
    x2: 557.63,
    y2: 410.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 358.74,
    y1: 207.6,
    x2: 376.01,
    y2: 150.81,
    xlinkHref: "#linear-gradient-3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shap") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.58.68s-30.76,69,65,38.36,80.92,11.67,68,33c-14,23.13-32.68,37.21-31,60.08,2.19,30,46.17,31.11,83.06,50.19,89.06,46.08-11.55,7.7-45.48,29.74s-13.23,38.45,33.71,36.77c101.38-3.64,67.76,30.66,50.82,46.19s-14,51,65.77,27,49.79,34,49.79,34h84V.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.15.68S391.5-5.3,371.09,70c-22.24,82.09,48.89,120.68,73,101.84s25.22-44.45-12.34-61.35-33.78-69,48.34-56S571.74,172,512.24,197s-45,54.44,19,85.72,29,73.23,29,73.23h40V.68Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroimg1);
export default __webpack_public_path__ + "static/media/introimg1.e8967a78fc6abad20b36cdf69a16992f.svg";
export { ForwardRef as ReactComponent };